// SCROLL TO ERRORS
export default {
  bind(el) {
    el.$handler = () => { // eslint-disable-line
      const inputs = document.querySelectorAll('.select-box-holder, .input-box-holder, .check-box, .radio-button-box');
      // Set dirty class
      inputs.forEach((input) => {
        if (!input.classList.contains('input-dirty')) input.classList.add('input-dirty');
      });
      // Find error inputs
      const errorInputs = document.querySelectorAll('.has-error');
      if (errorInputs.length > 0) {
        const errorInput = errorInputs[0];
        const rect = errorInput.getBoundingClientRect();
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const top = rect.top + scrollTop - 150;
        window.scrollTo({
          top,
          left: 0,
          behavior: 'smooth',
        });
      }
    };
    el.addEventListener('click', el.$handler);
  },
  unbind(el) {
    if (el.$handler) el.removeEventListener('click', el.$handler);
  },
};
